<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.editContactPerson') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-contact-person-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.nameAndSurename') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('ui.emailAddress') }}:
            </label>

            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="email"
                v-model="email" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.telephone') }}:
            </label>

            <validation-provider
              rules="required"
              name="phone"
              v-slot="{ errors }">
              <d-input
                v-mask="'+## ### ### ### ### ### ### ### ### ###'"
                :state="errors.length ? 'invalid' : null"
                v-model="phone" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('customer.excludeFromStockReports') }}:
            </label>

            <div>
              <d-checkbox inline v-model="exclude_from_stock_report" toggle toggle-small />
            </div>
          </div>

          <div class="form-group">
            <label>
              {{ $t('customer.newsletterAgreement') }}:
            </label>

            <span
              :class="{
                'text-success': newsletter_status === 'SUBSCRIBED',
                'text-danger': newsletter_status === 'UNSUBSCRIBED'
              }">
              <template v-if="newsletter_status === 'SUBSCRIBED'">
                {{ $t('customer.newsletterStatus.subscribed') }}
              </template>
              <template v-if="newsletter_status === 'UNSUBSCRIBED'">
                {{ $t('customer.newsletterStatus.unsubscribed') }}
              </template>
              <template v-if="newsletter_status === null">
                {{ $t('customer.newsletterStatus.null') }}
              </template>

              <div>
                <d-checkbox inline v-model="mailing_consent" toggle toggle-small />
              </div>
            </span>

            <label>
              {{ $t('customer.newsletterStatusAt') }}:
            </label>
            <div>
              <template v-if="newsletter_status_at">
                {{ newsletter_status_at }}
              </template>
              <template v-else>
                &mdash;
              </template>
            </div>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-contact-person-edit-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    contactPersonData: {
      default: () => ({}),
      type: Object
    }
  },
  data () {
    return {
      id: 0,
      name: '',
      email: '',
      phone: '',
      newsletter_status: null,
      newsletter_status_at: null,
      exclude_from_stock_report: false,
      mailing_consent: false
    };
  },
  mounted () {
    this.id = this.contactPersonData.id;
    this.name = this.contactPersonData.name;
    this.email = this.contactPersonData.email;
    this.phone = this.contactPersonData.phone;
    this.exclude_from_stock_report = !!this.contactPersonData.exclude_from_stock_report;
    this.newsletter_status = this.contactPersonData.newsletter_status;
    this.newsletter_status_at = this.contactPersonData.newsletter_status_at;
    this.mailing_consent = this.newsletter_status === 'SUBSCRIBED';
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-edit-contact-person-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-contact-person-edit-form'], this.saveContactPerson);
    },
    saveContactPerson () {
      let formDataToSave = {
        customer_id: this.customerID,
        name: this.name,
        email: this.email,
        phone: this.phone,
        exclude_from_stock_report: this.exclude_from_stock_report,
        mailing_consent: this.mailing_consent
      };

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customers/contacts/update/' + this.id,
        formData: formDataToSave,
        successTitle: this.$t('customer.editContactPersonSuccessTitle'),
        successText: this.$t('customer.editContactPersonSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.editContactPersonErrorText'),
        successAction: () => {
          this.$bus.$emit('customer-reload-contact-persons');
          this.handleClose();
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
